import React, { useState, useEffect } from 'react'
import { Alert, Button, Form, Input, Modal, Radio, Select, Tooltip, notification } from 'antd'
import { createBatchByIds, listLevels, listPartner } from "../../../../../services/api/3dApi"
import queryString from "query-string"

const { Option } = Select


const ActionSend = ({ isOpen, closeModal, selectedItems, refreshBatches,setSelectedItems}) => {

    const [levels, setLevels] = useState([])
    const [partners, setPartners] = useState([])
    const [error, setError] = useState('')
    const [errPartner, setErrPartner] = useState('')
    const [errLevel, setErrLevel] = useState('')
    const [loading, setLoading] = useState(false)
    const [user, setUser] = useState('')
    const [level, setLevel] = useState('1')
    const [partner, setPartner] = useState('')
    const [validate, setValidate] = useState('')

    const _fetchLevels = async () => {
        try {
            setLoading(true)
            const { data: response } = await listLevels()

            const { success, error, data } = response

            if (!success) {
                setErrLevel(error)
                return
            }

            setLevels(data)
            setLoading(false)

        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    const _fetchPartners = async () => {
        try {
            setLoading(true)
            const payload = {
                type: 'print_partner'
            }
            const query = queryString.stringify(payload)

            const { data: response } = await listPartner(query)

            const { success, error, data } = response

            if (!success) {
                setErrPartner(error)

                return
            }

            setPartners(data.partners || [])
            setLoading(false)

        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    useEffect(() => {
        _fetchLevels()
        _fetchPartners()
    }, [])

    const _handleChangeInput = (e) => {
        setUser(e.target.value)
        setValidate('')
    }

    const _handleChangePartner = (value) => {
        setPartner(value)
        setErrPartner('')
    }

    const _handleChange = e => {
        setLevel(e.target.value)
        setErrLevel('')
    }

    const _onRecycleBatch = async () => {
        setLoading(true)
        setError('')

        try {
            if (user === undefined || user === '') {
                setLoading(false)
                setValidate('Vui lòng nhập vào người tái tạo lô.')

                return
            }

            const params = {
                user_create: user,
                level: level,
                partner,
                ids: selectedItems
            }

            const { data: response } = await createBatchByIds(params)

            const { success, error, data } = response

            if (!success) {
                setLoading(false)
                setError(error)

                return
            }

            setLoading(false)
            closeModal()
            refreshBatches()
            setSelectedItems([])

            if (data.batch._id) {
                const win = window.open(`/batches/${data.batch._id}`, "_blank")
                win.focus()
            }

            if (!!data.errorMessages && data.errorMessages.length > 0) {
                notification.error({
                    message: 'Lỗi',
                    description: data.errorMessages.map((item, index) => {
                        return <p className='mb-0' key={index}>{item}</p>
                    })
                })
            }
        } catch (e) {
            setLoading(false)
            setError(e.message)
        }
    }

    return (
        <div className='ActionSend'>
            <Modal
                visible={isOpen}
                title="Tái tạo lô"
                onOk={_onRecycleBatch}
                onCancel={closeModal}
                footer={[
                    <Button key="back" onClick={closeModal}>
                        Hủy
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        loading={loading}
                        onClick={_onRecycleBatch}
                    >
                        Tái tạo
                    </Button>
                ]}
            >
                {error && <Alert message={error} type='error' className='mb-3' />}

                <Form.Item
                    label='Tên người tái tạo lô'
                    validateStatus={validate && 'error'}
                    help={validate}
                >
                    <Input
                        value={user}
                        onChange={_handleChangeInput}
                    />
                </Form.Item>

                <Form.Item
                    label={
                        <span>
                            Chọn đối tác
                            <Tooltip title="Chỉ đang hiển thị các partner in ép.">
                                <i className='fa fa-info-circle mx-1 cursor-pointer' />
                            </Tooltip>
                        </span>
                    }
                    validateStatus={errPartner && 'error'}
                    help={errPartner}
                >
                    <Select
                        onChange={_handleChangePartner}
                        defaultValue={partner}
                        dropdownClassName='custom-select-partner'
                    >
                        <Option value=''>---Hãy chọn một đối tác---</Option>
                        {
                            partners.length > 0 && partners.map(item => {
                                return <Option key={item._id} value={item._id}>{item.name}</Option>
                            })
                        }
                    </Select>
                </Form.Item>

                <Form.Item
                    label='Độ ưu tiên của lô'
                    validateStatus={errLevel && 'error'}
                    help={errLevel}
                >
                    <Radio.Group
                        onChange={_handleChange}
                        defaultValue={level}
                    >
                        {
                            levels.length > 0 && levels.map(item => {
                                return <Radio key={item.key} value={item.key}>{item.value}</Radio>
                            })
                        }
                    </Radio.Group>
                </Form.Item>
            </Modal>
        </div>
    )
}

export default ActionSend